import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-right-gray.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-start" }
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = { class: "grid grid-cols-2" }
const _hoisted_4 = { class: "flex gap-4 items-end" }
const _hoisted_5 = { class: "text-20px text-black-lp-300 col-span-2 capitalize font-semibold" }
const _hoisted_6 = { class: "flex flex-row col-span-2 text-gray-lp-600 items-center mt-2 font-medium" }
const _hoisted_7 = { class: "pr-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "arrow-right"
}, null, -1)
const _hoisted_9 = { class: "px-2" }
const _hoisted_10 = { class: "text-12px xxl:text-14px text-gray-lp-600 border-l border-gray-lp-400 px-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-12px xxl:text-14px text-gray-lp-600 border-l border-gray-lp-400 px-2"
}
const _hoisted_12 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_0,
  class: "w-6",
  alt: ""
}
const _hoisted_14 = {
  key: 2,
  class: "text-12px xxl:text-14px text-gray-lp-600 px-2"
}
const _hoisted_15 = { class: "flex items-center px-2 border-l border-gray-lp-400 text-gray-lp-600" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "h-11 px-4 py-3 rounded-lg bg-blue-lp-600 text-blue-lp-500 text-xs mt-2 inline-flex" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "pl-12"
}
const _hoisted_21 = { class: "pb-2 gap-4 flex w-full overflow-x-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CardDetailFlight = _resolveComponent("CardDetailFlight")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Icons, {
          name: _ctx.cargoType.icon,
          class: "w-8 mr-4 text-gray-lp-600"
        }, null, 8, ["name"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(`${_ctx.$t("Kargo")} ${_ctx.$t(_ctx.cargoType.label)}`), 1),
            (_ctx.showChangeCargo)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: ["text-base font-semibold", 
              `${
                _ctx.isLoadingCalculateVolume
                  ? 'text-gray-lp-600 cursor-not-allowed'
                  : 'text-red-lp-100 cursor-pointer'
              }`
            ],
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCargo && _ctx.changeCargo(...args)))
                }, _toDisplayString(_ctx.$t("cargo.actions.editCargo")), 3))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.originCity), 1),
            _hoisted_8,
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.destinationCity), 1),
            (_ctx.isPlaneAuto && _ctx.formBooking.flightsData.length && !_ctx.isRTC)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDate(_ctx.formBooking.estDepartureDate)), 1),
                  (_ctx.formBooking.flightsData.length)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        (_ctx.formBooking.flightsData[0]?.DepartureDateTime)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              (_ctx.formBooking.flightsData.length === 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_12, "Langsung"))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTimeNumber(_ctx.formBooking.flightsData[0].DepartureDateTime)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                  _ctx.formBooking.flightsData[_ctx.formBooking.flightsData.length - 1]
                    ?.ArrivalDateTime && _ctx.isChangeCargoType
                )
                          ? (_openBlock(), _createBlock("img", _hoisted_13))
                          : _createCommentVNode("", true),
                        (
                  _ctx.formBooking.flightsData[_ctx.formBooking.flightsData.length - 1]
                    ?.ArrivalDateTime && _ctx.isChangeCargoType
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.formatTimeNumber(
                    _ctx.formBooking.flightsData[_ctx.formBooking.flightsData.length - 1]
                      .ArrivalDateTime
                  )), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_15, [
                          (_ctx.formBooking.flightsData.length > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("cargo.planeSchedule.transitCount", {
                      count: _ctx.formBooking.flightsData.length - 1
                    })), 1))
                            : _createCommentVNode("", true),
                          (
                    _ctx.flowBooking === 'manual' ||
                      (_ctx.flowBooking === 'rebooking' &&
                        _ctx.$route.query.rcId &&
                        !_ctx.isFromRebookingRTC)
                  )
                            ? (_openBlock(), _createBlock("div", {
                                key: 1,
                                class: "flex items-center ml-2 cursor-pointer text-red-lp-300 font-medium",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onToggleFlightsDetail && _ctx.onToggleFlightsDetail(...args)))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("cargo.actions.viewDetail")) + " ", 1),
                                _createVNode("img", {
                                  src: 
                      require(`@/app/ui/assets/svg/chevron-down-bold-red.svg`)
                    ,
                                  class: "w-5 rotate-180",
                                  style: 
                      _ctx.toggleFlightsDetail ? 'transform: rotateX(180deg);' : ''
                    ,
                                  alt: "chevron-down"
                                }, null, 12, ["src"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _withDirectives(_createVNode("div", _hoisted_17, [
        _createVNode(_component_Icons, {
          name: "info",
          class: "w-4 mr-2"
        }),
        (_ctx.nextCotHour)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargo.labels.estimatedDeparture")) + ": ", 1),
              _createVNode("b", null, _toDisplayString(_ctx.displayNextCotHour), 1)
            ]))
          : (_ctx.cotHour)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(_ctx.$t("cargo.labels.estimatedDeparture")) + ": ", 1),
                _createVNode("b", null, _toDisplayString(_ctx.displayCotHour), 1)
              ]))
            : _createCommentVNode("", true)
      ], 512), [
        [_vShow, 
        _ctx.hasCotOrNextSchedule && _ctx.isPlaneAuto && _ctx.flowBooking !== 'rebooking'
      ]
      ])
    ]),
    (_ctx.formBooking.flightsData.length)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formBooking.flightsData, (item, index) => {
              return (_openBlock(), _createBlock(_component_CardDetailFlight, {
                key: `${index}`,
                flightDetail: item,
                flightIndex: index
              }, null, 8, ["flightDetail", "flightIndex"]))
            }), 128))
          ])
        ], 512)), [
          [_vShow, _ctx.toggleFlightsDetail]
        ])
      : _createCommentVNode("", true)
  ], 64))
}